import script from "./OfferCompareModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferCompareModal.vue?vue&type=script&setup=true&lang=js"

import "./OfferCompareModal.vue?vue&type=style&index=0&id=2a29f801&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a29f801"]])

export default __exports__